module.exports = __webpack_public_path__ + "img/czdl.1ab89917.jpg";